var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.condicionesTexto)?_c('div',{staticClass:"condiciones m-1",domProps:{"innerHTML":_vm._s(_vm.condicionesTexto)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }